
export { default as SettingsIconSelect } from "./settings_icon_select.svg"
export { default as SettingsIconSelected } from "./settings_icon_selected.svg"